<template>
  <el-container>
    <el-table :data="customers" @row-click="rowClick">
      <el-table-column>
        <template>
          <el-icon class="el-icon-arrow-left"></el-icon>
        </template>
      </el-table-column>
      <el-table-column prop="name">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            size="mini"
            v-model="filter"
            :placeholder="$t('search.placeholder')"
          />
        </template>
      </el-table-column>
    </el-table>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "customersList",
  data() {
    return {
      filter: ""
    };
  },
  created() {
    this.getData();
  },
  watch: {
    opened(v) {
      if (v) {
        return;
      }
      this.$emit("update:merge_mode", false);
    }
  },
  methods: {
    getData() {
      if (this.customers.length) {
        return;
      }
      this.$api.query({
        query: require("../../../../graphql/customers/customers_list.graphql")
      });
    },
    rowClick(...args) {
      this.$log(args);
      this.$emit("update:customer_for_merge", args[0]);
    }
  },
  computed: {
    ...mapGetters({
      customer: "shared_customers/customer",
      customers_list: "shared_customers_list/customers"
    }),
    customers() {
      return this.customers_list.filter(
        v =>
          v.uuid !== this.customer.uuid &&
          (this.filter
            ? v.name.toLowerCase().includes(this.filter.toLowerCase())
            : true)
      );
    }
  }
};
</script>

<style scoped></style>
